import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import shipingService from "../services/shiping-service";
import cogoToast from "cogo-toast";
import CutOffPopUp from "../Components/CutOffPopUp";
import { kaPropsUtils } from "ka-table/utils";
import Loader from "react-loader-spinner";
import { kaReducer, Table } from "ka-table";
import { search, loadData, updateData } from "ka-table/actionCreators";
import { ActionType, SortingMode, PagingPosition } from "ka-table/enums";
import {
  deselectRow,
  selectRow,
  selectRowsRange,
} from "ka-table/actionCreators";
const tablePropsInit = {
  columns: [
    { key: "fac_id" },
    { key: "fac_name", title: "Facility Id" },
    { key: "fac_code", title: "Dcode" },
    { key: "fac_workflow", title: "Sorter Code" },
    { key: "que_code", title: "Que" },
    { key: "is_control", title: "Control" },
    { key: "is_dollar", title: "$$" },
    { key: "is_fridge", title: "Fridge" },
    { key: "scripts", title: "Scripts" },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "fac_id",
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom,
  },
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
};
const CutOffScreenTab = ({ history }) => {
  const { handleSubmit } = useForm({});
  const [loading, setLoading] = useState(false);
  const [edituserOpen, setEditUserOpen] = useState(false);
  const [tableProps, changeTableProps] = useState(tablePropsInit);
  const selectedFacs = kaPropsUtils.getSelectedData(tableProps);
  const [showFacilityList, setShowFacilityList] = useState("hidden");
  async function handleCutOffTime() {
    setLoading(true);
    try {
      let resp = await shipingService.getCutOffFacility();
      if (resp.length > 0) {
        setEditUserOpen(true);
        setShowFacilityList("");
        dispatch1(updateData(resp));
      } else {
        const { hide } = cogoToast.error("No Records Found.", {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        });
        setLoading(false);
        setShowFacilityList("hidden");
        dispatch1(updateData());
      }
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error retrieving Cut Off details. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
    setLoading(false);
  }
  let dispatch1 = async (action) => {
    changeTableProps((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData) {
    }
  };
  const SelectionCell = ({
    rowKeyValue,
    dispatch: dispatchCutOff,
    isSelectedRow,
    selectedRows,
  }) => {
    return (
      <input
        type="checkbox"
        checked={isSelectedRow}
        onChange={(event) => {
          if (event.nativeEvent.shiftKey) {
            dispatchCutOff(
              selectRowsRange(rowKeyValue, [...selectedRows].pop())
            );
          } else if (event.currentTarget.checked) {
            dispatchCutOff(selectRow(rowKeyValue));
          } else {
            dispatchCutOff(deselectRow(rowKeyValue));
          }
        }}
      />
    );
  };
  const SelectionHeader = () => {
    return <span className="font-semibold">Ready for Audit</span>;
  };
  const CustomCell = ({ rowData }) => {
    return (
      <div className="text-sm text-center">
        {rowData?.is_control ? "C" : ""}
      </div>
    );
  };
  const CustomCell1 = ({ rowData }) => {
    return (
      <div className="text-sm text-center">
        {rowData?.is_dollar ? "$$" : ""}
      </div>
    );
  };
  const CustomCell2 = ({ rowData }) => {
    return (
      <div className="text-sm text-center">
        {rowData?.is_fridge > 0 ? rowData?.is_fridge : ""}
      </div>
    );
  };
  const CustomCell3 = ({ rowData }) => {
    return <div className="text-sm text-center">{rowData?.fac_id}</div>;
  };

  const cutoffSubmit = async (data) => {
    if (selectedFacs.length > 0) {
      try {
        const params = [];
        selectedFacs.map((selectedFac, i) => {
          return params.push({
            facility: selectedFac.fac_id,
            isChecked: true,
          });
        });
        await shipingService.submitCutOffForm(params);
        const { hide } = cogoToast.success("Success", {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        });
        handleCutOffTime();
      } catch (e) {
        const { hide } = cogoToast.error(
          "Error submitting Cut Off details. Please try after sometime.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
        handleCutOffTime();
      }
    } else {
      const { hide } = cogoToast.error("Please select atleast one facility.", {
        hideAfter: 15,
        onClick: () => {
          hide();
        },
      });
    }
  };
  useEffect(() => {
    handleCutOffTime();
  }, []);
  return (
    <div className="">
      <div
        className={`inline-block customtop z-50 absolute ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00B2A9"
          height={50}
          width={50}
          timeout={300000}
        />
      </div>
      <div>
        <button
          onClick={handleCutOffTime}
          type="submit"
          className={`text-white w-full sm:w-auto h-8 px-6 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none float-right inline-block mr-3 mb-1`}
        >
          REFRESH
        </button>
      </div>
      <div
        className={`inline-block customtop w-full cutOffFacTable ${showFacilityList}`}
      >
        <div className="w-full text-right">
        <span className="relative">
              <input
                type="search"
                defaultValue={tableProps.searchText}
                onChange={(event) => {
                  dispatch1(search(event.currentTarget.value));
                }}
                placeholder=" Search"
                className="border rounded w-5/12 h-10 mr-3 focus:outline-none focus:none pl-1 font-light align-bottom mt-3"
              />
              <img
                src="/img/search-2.svg"
                alt=""
                className="absolute w-4 h-4 right-5 -top-2 bottom-3"
              ></img>
            </span>
        </div>
        <div className="p-2 gridList overflow-x-auto">
          <form onSubmit={handleSubmit(cutoffSubmit)}>
            <Table
              {...tableProps}
              childComponents={{
                cellText: {
                  content: (props) => {
                    // eslint-disable-next-line default-case
                    switch (props.column.key) {
                      case "fac_id":
                        return <SelectionCell {...props} />;
                      case "fac_name":
                        return <CustomCell3 {...props} />;
                      case "is_control":
                        return <CustomCell {...props} />;
                      case "is_dollar":
                        return <CustomCell1 {...props} />;
                      case "is_fridge":
                        return <CustomCell2 {...props} />;
                    }
                  },
                },
                filterRowCell: {
                  content: (props) => {
                    if (props.column.key === "fac_id") {
                      return <></>;
                    }
                  },
                },
                headCell: {
                  content: (props) => {
                    if (props.column.key === "fac_id") {
                      return <SelectionHeader {...props} />;
                    }
                  },
                },
              }}
              dispatch={dispatch1}
            />
            <div className="w-full inline-block">
              <button
                type="submit"
                className="text-white rounded font-medium h-10 w-1/5 bg-login_btn my-3 focus:outline-none float-right mr-4"
                aria-label="Create user"
              >
                SUBMIT
              </button>
            </div>
          </form>
        </div>
      </div>
      <CutOffPopUp
        setEditUserOpen={setEditUserOpen}
        edituserOpen={edituserOpen}
      />
    </div>
  );
};
export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(CutOffScreenTab)
);
